
export interface SearchForm {
  number: number | string
  receiver_phone: number | string
  express_number: number | string
  type: number | string
  status: number | string
  orderStart: string // 下单开始时间
  orderEnd: string
  deliverStart: string // 发货开始时间
  deliverEnd: string
  importStart: string // 导入开始时间
  importEnd: string
  limit: number
  offset: number
}

export interface OrderDetails {
  id: number
  number: string
  pay_amount: number
  out_trade_number: string
  receive_address: string
  express_number: number
  remark: string
  status: number
  items: any[]
  pay_type: number
  express_company_id: number
  receiver: string
  receiver_phone: string
  createdAt: string
  pay_at: string
  deliver_at: string
  express_fee: string
  selectCoupon: any
  discount_amount: number
  refunds: any
  deliver: any
  user: any
  sale: any
  adjustPrice: any
  is_sale: boolean
  is_external: boolean
  is_design_order: boolean
}

export interface AddShoppingCart {
  price: number
  quality: number // 数量
  spu_customable_image: string // pms_product_spu_customable_image[0]
  spu_name: string // pms_product_spu.name
  custom_spu_name: string // pms_custom_spu.name
  custom_spu_customized_image: string // 背景图
  custom_sku_code: number
  custom_sku_attrs: string
  spu_custom_width: number
  spu_custom_height: number
  spu_custom_areas: {
    top: number
    left: number
    id: number
    width: number
    height: number
  }
  custom_sku_id: number // 用户自定义商品的ID
}
export type Color = {
  name: string,
  value: string
}
export const convertColor = (strColor: any): Color | undefined => {
  if (typeof strColor !== 'string') {
    return strColor
  }
  try {
    return JSON.parse(strColor)
  } catch (e) {
    return { name: '', value: strColor }
  }
}
